import api from '@/services/Api';

class TransporterService {
  async askTransporterByMailToRepairer(data) {
    const response = await api.post('/distributor/transporter/repairer', data)
    return response.data
  }

  async getTransporter(data) {
    const response = await api.post('/distributor/transporter', data)
    return response.data
  }
}

export default new TransporterService()
